/**
 * Readable text for a location or territory. Both are free text today (no master data), and the
 * seed/scripts store them as technical ids (`loc_caracas_main`). A value that looks like such an
 * id is shown as words ("Caracas main"); anything a person typed ("Caracas Norte") is shown as is.
 * Display only: the stored value never changes, so filters and links keep using the raw one.
 */
const TECHNICAL_ID = /^[a-z][a-z0-9]*(_[a-z0-9]+)+$/;
const KNOWN_PREFIX = /^(loc|territory|terr|ter)_/;

/**
 * Readable number of an order / quote (PED-000123 / COT-000123). Documents created before
 * numbering have none, so they keep showing their technical id and nothing breaks.
 */
export const orderLabel = (order: { orderId: string; orderNumber?: string }): string =>
  order.orderNumber ?? order.orderId;
export const quoteLabel = (quote: { quoteId: string; quoteNumber?: string }): string =>
  quote.quoteNumber ?? quote.quoteId;
/** Readable number of a payment (PAG-000123); older payments keep their technical id. */
export const paymentLabel = (payment: { paymentId: string; paymentNumber?: string }): string =>
  payment.paymentNumber ?? payment.paymentId;

export function placeLabel(value: string | undefined | null): string {
  if (!value) return '—';
  const trimmed = value.trim();
  if (!TECHNICAL_ID.test(trimmed)) return trimmed;
  const words = trimmed.replace(KNOWN_PREFIX, '').split('_').join(' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
}
